import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ICreateExportInvoiceRequest,
    IExportInvoice,
    IExportInvoiceLine,
    IReplaceExportInvoiceLinesRequest,
    IUpdateExportInvoiceRequest,
} from '../interfaces/exportInvoice.interface';
import { PageResponse } from '../interfaces/commercial.interface';

/** Export invoice (15.1, plan task 7) — header + line child rows (replace-all, not per-line CRUD),
 * roll-ups computed server-side. Returns data only — components own triggerDownload/showApiError
 * per house rules (copies packingList.service.ts exactly). */
export const ExportInvoiceService = {
    list: async (
        institutionId: string,
        params: { buyerOrderId?: string; q?: string; from?: string; to?: string; page?: number; size?: number } = {},
    ): Promise<PageResponse<IExportInvoice>> => {
        const { buyerOrderId, q, from, to, page = 0, size = 20 } = params;
        return (await axios.get(ENDPOINTS.EXPORT_INVOICE.LIST(institutionId), {
            params: { buyerOrderId, q, from, to, page, size },
        })).data;
    },
    get: async (institutionId: string, id: string): Promise<IExportInvoice> =>
        (await axios.get(ENDPOINTS.EXPORT_INVOICE.GET(institutionId, id))).data,
    create: async (institutionId: string, dto: ICreateExportInvoiceRequest): Promise<IExportInvoice> =>
        (await axios.post(ENDPOINTS.EXPORT_INVOICE.CREATE(institutionId), dto)).data,
    update: async (institutionId: string, id: string, dto: IUpdateExportInvoiceRequest): Promise<IExportInvoice> =>
        (await axios.put(ENDPOINTS.EXPORT_INVOICE.UPDATE(institutionId, id), dto)).data,
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.EXPORT_INVOICE.DELETE(institutionId, id));
    },

    // ---- line rows (replace-all) ---------------------------------------------------------------
    listLines: async (institutionId: string, id: string): Promise<IExportInvoiceLine[]> =>
        (await axios.get(ENDPOINTS.EXPORT_INVOICE.LIST_LINES(institutionId, id))).data,
    replaceLines: async (
        institutionId: string, id: string, dto: IReplaceExportInvoiceLinesRequest,
    ): Promise<IExportInvoice> =>
        (await axios.put(ENDPOINTS.EXPORT_INVOICE.REPLACE_LINES(institutionId, id), dto)).data,

    // ---- pdf ------------------------------------------------------------------------------------
    downloadPdf: async (institutionId: string, id: string): Promise<Blob> =>
        (await axios.get(ENDPOINTS.EXPORT_INVOICE.PDF(institutionId, id), { responseType: 'blob' })).data,
};
